(function (skyward, $)
{
    "use strict";

    skyward.htmlgatherer = skyward.htmlgatherer || {};

    var defaultSettings =
    {
        stripJavaScript: false,
        isMassPrintOnlineForm: false,
    };

    skyward.htmlgatherer.getHtml = function (html, options)
    {
        return skyward.htmlgatherer.getNode(html, options).then(node => node.html());
    };

    skyward.htmlgatherer.getNode = async function (html, options)
    {
        var settings = $.extend({}, defaultSettings, options);
        var originalHtml;
        var clonedHtml;

        originalHtml = $(html);

        if (settings.isMassPrintOnlineForm)
        {
            // Mass Print Online Form does weird things, don't worry about it
            return originalHtml;
        }
        clonedHtml = originalHtml.clone();

        if (settings.stripJavaScript)
        {
            clonedHtml.find("script").remove(); // Strip all pre-existing JavaScript from the clone
        }
        setValuesForInputs(getValuesForInputs(originalHtml), clonedHtml);
        setValuesForSelects(getValuesForSelects(originalHtml), clonedHtml);
        setCanvasImages(originalHtml, clonedHtml);
        await setIframeSrcdocs(originalHtml, clonedHtml, settings);

        return clonedHtml;
    };

    skyward.htmlgatherer.getOuterHtml = function (html)
    {
        var node = html instanceof $ ? html[0] : html;
        if (!node)
        {
            return;
        }
        if (node.nodeType === Node.DOCUMENT_NODE)
        {
            node = node.documentElement;
        }
        var doctype = node.ownerDocument ? node.ownerDocument.doctype : undefined;
        var doctypeStr = doctype ? new XMLSerializer().serializeToString(doctype) : "";
        return doctypeStr + node.outerHTML;
    };

    skyward.htmlgatherer.getValues = async function (html)
    {
        var result =
        {
            inputs: getValuesForInputs(html),
            selects: getValuesForSelects(html),
            iframes: await getValuesForIframes(html),
        };
        return result;
    };

    skyward.htmlgatherer.setValues = async function (values, html)
    {
        setValuesForInputs(values.inputs, html);
        setValuesForSelects(values.selects, html);
        await setValuesForIframes(values.iframes, html);
    };

    function getValuesForInputs(originalHtml)
    {
        return originalHtml.find(":is(input,textarea):not(.doNotPost:hidden)").toArray().map(function (elem)
        {
            var input = $(elem);
            return input.is(":checkbox") || input.is(":radio")
                ? input.is(":checked")
                : input.val();
        });
    }

    function setValuesForInputs(values, html)
    {
        html.find(":is(input,textarea):not(.doNotPost:hidden)").each(function (index)
        {
            var originalValue = values[index];
            var input = $(this);

            if (input.is(":checkbox") || input.is(":radio"))
            {
                input.attr("checked", originalValue ? "checked" : null);
            }
            else if (input.is("input"))
            {
                input.attr("value", originalValue);
            }
            else
            {
                input.text(originalValue);
            }
        });
    }

    function getValuesForSelects(html)
    {
        return html.find('select:not(.doNotPost:hidden)').toArray().map(function (elem)
        {
            return elem.selectedIndex;
        });
    }

    function setValuesForSelects(values, clonedHtml)
    {
        clonedHtml.find("select:not(.doNotPost:hidden)").each(function (selectIndex)
        {
            var selectedIndex = values[selectIndex];
            $(this).find("option").each(function (optionIndex)
            {
                var option = $(this);

                if (selectedIndex === optionIndex)
                {
                    option.attr("selected", "selected");

                    // EvoPDF disregards label attributes and only renders options' inner text
                    var label = option.attr("label");
                    if (label !== undefined)
                    {
                        option.text(label);
                    }
                }
                else
                {
                    option.removeAttr("selected");
                }
            });
        });
    }

    function getValuesForIframes(originalHtml)
    {
        return Promise.all(originalHtml.find("iframe").toArray().map(async function (elem)
        {
            // chrome adds an iframe when you translate a page; ignore errors from it
            try
            {
                return await skyward.iframeListener.getHtmlValues(elem);
            }
            catch (ex) { }
        }));
    }

    function setValuesForIframes(values, clonedHtml)
    {
        return Promise.all(clonedHtml.find("iframe").toArray().map(function (iframe, iframeIndex)
        {
            return skyward.iframeListener.setHtmlValues(iframe, values[iframeIndex]);
        }));
    }

    var setIframeSrcdocs = function (originalHtml, clonedHtml, options)
    {
        var originalIframes = originalHtml.find("iframe");
        return Promise.all(clonedHtml.find("iframe").toArray().map(async function (iframe, index)
        {
            let outerHtmlValue = null;
            try
            {
                outerHtmlValue = await skyward.iframeListener.getOuterHtml(originalIframes[index], options);
            }
            catch (ex) { }
            if (outerHtmlValue)
            {
                $(iframe).attr("srcdoc", outerHtmlValue);
            }
        }));
    };

    const setCanvasImages = function (originalHtml, clonedHtml)
    {
        const originalCanvases = originalHtml.find("canvas");
        clonedHtml.find("canvas").toArray().forEach((canvas, index) =>
        {
            const original = originalCanvases[index];
            try
            {
                const encoded = original.toDataURL();
                // At non-100% zoom, the CSS size may be different from the dimensions specified by the canvas's attributes
                const style = original.getBoundingClientRect();
                const image = $("<image>").attr({
                    width: style.width || original.width,
                    height: style.height || original.height,
                    src: encoded
                })
                $(canvas).replaceWith(image);
            }
            catch (ex) { }
        });
    }

}(window.skyward = window.skyward || {}, window.jQuery));
